<template>
  <div>
    <layout-one>
      <el-form
        :model="form"
        label-width="160px"
        :inline="true"
        ref="form"
        :rules="rules"
      >
        <div class="section">
          <!-- examType 考试类型 -->
          <div class="sectionBox">
            <el-form-item label="考试类型">
              <el-radio-group v-model="form.examTypeId" :disabled="isClassPublish">
                <el-radio-button :label="item.id" class="examType" v-for="item in examTypeList" :key="item.id">{{item.name}}</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>

          <h4>基本信息</h4>
          <!-- planCode 考试批次编码 -->
          <div class="sectionBox">
            <el-form-item label="考试批次">
              <span>{{ planCode }}</span>
            </el-form-item>
          </div>
          <!-- isPublist 考试批次是否发布 -->
          <div class="sectionBox">
            <el-form-item label="考试批次名称" prop="name">
              <el-input
                placeholder="请输入"
                v-model="form.name"
                :disabled="isPublish"
                class="inputwidth"
              ></el-input>
            </el-form-item>
          </div>
          <!-- isNeedAudit : 报名审核是否禁用 -->
          <!-- examTypeChange : 切换审核方式修改时间设置 -->
          <!-- needAudit : { 1: '一级', 2: '二级', 3: '不审核' }  -->
          <div class="sectionBox">
            <el-form-item label="报名人工审核" :required="true">
              <el-radio-group
                v-model="form.needAudit"
                @change="examTypeChange"
                :disabled="isNeedAudit"
              >
                <el-radio-button label="1" class="examType"
                  >一级人工审核</el-radio-button
                >
                <el-radio-button label="2" class="examType"
                  >二级人工审核</el-radio-button
                >
                <el-radio-button label="0" class="examType"
                  >不做人工审核</el-radio-button
                >
              </el-radio-group>
            </el-form-item>
          </div>
          <!-- optionalSession : 考点场次 -->
          <!-- isNeedAudit : 报名审核是否禁用 -->
          <div class="sectionBox">
            <el-form-item label="允许选考试场次">
              <el-switch
                v-model="form.optionalSession"
                :active-value="1"
                :inactive-value="0"
                :disabled="isNeedAudit"
              ></el-switch>
            </el-form-item>
          </div>
          <!-- downloadEntrance : 是否下载准考证 -->
          <div class="sectionBox">
            <el-form-item label="下载准考证">
              <el-switch
                v-model="form.downloadEntrance"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </div>
          <!-- isPay : 是否开启缴费 -->
          <!-- isPublist 考试批次是否发布 -->
          <div class="sectionBox">
            <el-form-item label="是否开启缴费">
              <el-switch
                v-model="form.isPay"
                :active-value="1"
                :inactive-value="0"
                :disabled="isPublish"
              ></el-switch>
            </el-form-item>
          </div>
          <div class="sectionBox">
            <el-form-item label="允许学生成绩申诉">
              <el-switch
                v-model="form.scoreReview"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </div>
        </div>

        <div class="section mt20">
          <h4>时间设置</h4>
          <!-- beginSign : 报名开始时间 -->
          <!-- endSign : 报名截止时间 -->
          <!-- isClassPublish : 场次是否发布 -->
          <div class="sectionBox">
            <el-form-item label="报名起止时间" prop="beginSign">
              <el-date-picker
                :disabled="isClassPublish"
                :value-format="dataFormat"
                v-model="form.beginSign"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item> 至 </el-form-item>
            <el-form-item label="" prop="endSign">
              <el-date-picker
                :default-time="defaultTime"
                :disabled="isClassPublish"
                :value-format="dataFormat"
                v-model="form.endSign"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- primaryEndAudit : 初审截止时间 -->
          <!-- hiddenPrimaryEndAudit : 只有二级审核显示 -->
          <div class="sectionBox" v-if="hiddenPrimaryEndAudit">
            <el-form-item label="初审截止时间" prop="primaryEndAudit">
              <el-date-picker
                :disabled="isClassPublish"
                :value-format="dataFormat"
                v-model="form.primaryEndAudit"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- endAudit : 终审截止时间 -->
          <!-- hiddenEndAudit : 不做人工审核不显示 -->
          <div class="sectionBox">
            <el-form-item
              :label="endAuditLabel"
              prop="endAudit"
              v-if="hiddenEndAudit"
            >
              <el-date-picker
                :disabled="isClassPublish"
                :value-format="dataFormat"
                v-model="form.endAudit"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- startPay : 缴费开始时间 -->
          <!-- endPay : 缴费终止时间 -->
          <div class="sectionBox" v-if="form.isPay == 1">
            <el-form-item label="缴费起止时间" prop="startPay">
              <el-date-picker
                :disabled="isClassPublish"
                :value-format="dataFormat"
                v-model="form.startPay"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item> 至 </el-form-item>
            <el-form-item label="" prop="endPay">
              <el-date-picker
                :default-time="defaultTime"
                :disabled="isClassPublish"
                :value-format="dataFormat"
                v-model="form.endPay"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- downloadEntrance : 开启准考证 -->
          <!-- beginEntrance : 准考证打印时间 -->
          <div class="sectionBox">
            <el-form-item
              label="准考证打印开始时间"
              prop="beginEntrance"
              v-if="form.downloadEntrance"
            >
              <el-date-picker
                :value-format="dataFormat"
                v-model="form.beginEntrance"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- 考试起止时间 -->
          <div class="sectionBox">
            <el-form-item label="考试起止时间" prop="beginExam">
              <el-date-picker
                :disabled="isCreateSession || isClassPublish"
                :value-format="dataFormat"
                v-model="form.beginExam"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item> 至 </el-form-item>
            <el-form-item label="" prop="endExam">
              <el-date-picker
                :default-time="defaultTime"
                :disabled="isCreateSession || isClassPublish"
                :value-format="dataFormat"
                v-model="form.endExam"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- beginScoreCheck : 成绩查询时间 -->
          <div class="sectionBox">
            <el-form-item label="成绩查询开始时间" prop="beginScoreCheck">
              <el-date-picker
                :value-format="dataFormat"
                v-model="form.beginScoreCheck"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="sectionBox" v-if="form.scoreReview === 1">
            <el-form-item label="成绩申诉截止时间" prop="scoreReviewEndTime">
              <el-date-picker
                :value-format="dataFormat"
                v-model="form.scoreReviewEndTime"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </div>

        <div class="section mt20">
          <h4>课程设置</h4>
          <div class="sectionBox">
            <el-form-item label="考试科目选择" prop="form_courseIdList">
              <div class="stationBox">
                <!-- 快捷搜索功能 -->
                <div class="stationTop">
                  <div class="searchCourse ml30">
                    <el-input
                      placeholder="快捷搜索"
                      v-model="courseStr"
                    ></el-input>
                    <div class="searchPos">
                      <i class="iconfont icon-sousuo"></i>
                    </div>
                  </div>
                </div>
                <!-- 课程全选 -->
                <el-checkbox
                  :indeterminate="isIndeterminate"
                  v-model="checkAll"
                  @change="handleCheckAllChange"
                  :disabled="isPublish"
                  >全选</el-checkbox
                >
                <!-- 课程勾选 -->
                <el-checkbox-group
                  v-model="form.form_courseIdList"
                  @change="handleCheckedChange"
                >
                  <el-checkbox
                    :disabled="isPublish"
                    v-for="course in courseSelectData"
                    :label="course.id"
                    :key="course.id"
                    :title="course.name"
                    >{{ course.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div>
                <el-checkbox
                  v-if="signCoureCountall && form.form_courseIdList.length>= 2"
                  class="limitationcheckbox"
                  v-model="form.signCoureCount"
                  :true-label="1"
                  :false-label="0"
                  >单科目报名限制
                  <span>(此选项是控制学生在报名环节只能选择一个科目)</span>
                </el-checkbox>
              </div>
              <div v-if="form.optionalSession == 0">
                <el-checkbox 
                  class="limitationcheckboxs" 
                  label="允许学生选考试日期" 
                  v-if="form.form_courseIdList.length === 1"
                  v-model="form.optionalExamDate"
                  :true-label="1"
                  :false-label="0"
                >
                  允许学生选考试日期<span
                  >
                    限制每天<el-input
                      v-model="form.everyBodyLimit"
                      class="inputsize"
                    />人考试
                  </span>
                </el-checkbox>
                <el-checkbox
                class="limitationcheckboxs"
                  label="允许学生选考试日期"
                  v-else-if="
                   form.form_courseIdList.length >= 2&&
                   form.signCoureCount == 1
                  "
                  v-model="form.optionalExamDate"
                  :true-label="1"
                  :false-label="0"
                >
                  允许学生选考试日期<span
                  >
                    限制每天<el-input 
                      v-model="form.everyBodyLimit"
                      class="inputsize"
                    />人考试
                  </span>
                </el-checkbox>
              </div>



            </el-form-item>
          </div>
          <div class="section mt20" v-if="form.isPay == 1">
            <h4>费用设置</h4>
            <!-- (1) 收费标准 -->
            <div class="sectionBox" v-if="false">
              <el-form-item label="收费标准" prop="money">
                <el-input
                  class="short"
                  placeholder="请输入"
                  v-model="form.money"
                  :disabled="isPublish"
                >
                  <template slot="suffix">元/科</template>
                </el-input>
              </el-form-item>
            </div>
            <!-- (2) 缴费渠道 -->
            <div class="sectionBox">
              <el-form-item
                label="缴费渠道"
                :prop="form.isPay == 1 ? 'payType' : false"
              >
                <el-radio-group v-model="form.payType" :disabled="isPublish">
                  <el-radio-button label="1" class="examType" v-if="payCode > 0">平台在线缴费</el-radio-button>
                  <el-radio-button label="2" class="examType" >第三方自主缴费</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </div>
            <!-- (3) 选择的课程费用 -->
            <div class="sectionBox" v-show="form.isPay == 1 && form.payType">
              <el-form-item label="课程费用">
                <div class="stationBox">
                  <div
                    v-for="course in PayMentInfo.needPayCourse"
                    :key="course.id"
                    style="margin-bottom: 8px"
                  >
                    <el-form-item :label="course.name">
                      <el-input
                        placeholder="请输入"
                        v-model="PayMentInfo.PayCourse[course.id]"
                        @input="$forceUpdate()"
                        :disabled="isPublish"
                      >
                        <template slot="suffix">元&nbsp;&nbsp;</template>
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
              </el-form-item>
            </div>
            <!-- (4) 第三方自主缴费 - 二维码 -->
            <div class="sectionBox" v-if="form.payType == 2">
              <el-form-item label="第三方自主缴费二维码">
                <el-upload
                  action=""
                  :disabled="isOverPay"
                  class="avatar-uploader dinb"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                  :http-request="uploadImg"
                >
                  <img
                    v-if="payInfo.imageUrl"
                    :src="payInfo.imageUrl"
                    class="avatar"
                  />
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div class="avatarTip">
                  <p class="mb10">温馨提示：</p>
                  <p class="col_grayQ">1、请务必保证所上传二维码的准确性；</p>
                  <p class="col_grayQ">
                    2、二维码尺寸建议不小于300*300像素；支持jpg/png格式，大小不超过200KB；
                  </p>
                  <p class="col_grayQ">
                    3、缴费金额不填写，默认为0元；0元费用不建议上传缴费二维码；
                  </p>
                </div>
              </el-form-item>
            </div>
            <!-- (5) 缴费说明 -->
            <div class="sectionBox" v-if="form.payType == 2">
              <el-form-item label="缴费说明">
                <el-input
                  class="textarea"
                  type="textarea"
                  :disabled="isOverPay"
                  v-model="payInfo.paymentText"
                  placeholder="请添加缴费说明，以小写分号;分隔多条说明，可预览查看"
                ></el-input>
                <div class="col_blue cp pr preBtn">
                  <span>预览</span>
                  <span v-if="isOverPay" class="col_red ml5"
                    >(缴费时间已过，无法更改缴费相关信息)</span
                  >
                  <div class="codePreview col_black">
                    <div class="picArea">
                      <img
                        v-if="payInfo.imageUrl"
                        :src="payInfo.imageUrl"
                        alt=""
                      />
                    </div>
                    <div class="payContent">
                      <p v-for="(item, index) in payRemarkList" :key="index">
                        {{ `${index + 1}.${item}` }}
                      </p>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
        </div>
        <!-- 报名须知 -->
        <div class="section mt20">
          <h4>报名须知</h4>
          <div class="sectionBox edui-LMS">
            <el-form-item label="报名须知" prop="signRemark">
              <ots-editor
                v-show="!isOverSign"
                class="editor"
                v-model="form.signRemark"
              />
              <div
                v-show="isOverSign"
                class="unEditor"
                v-html="form.signRemark"
              ></div>
            </el-form-item>
          </div>
        </div>
        <!-- 准考证设置 -->
        <div class="section mt20" v-if="form.downloadEntrance == 1">
          <h4>准考证设置</h4>
          <div class="sectionBox">
            <el-form-item label="">
              <div class="stationBox">
                <el-form-item label="1.模板下载" label-width="90px">
                  <span
                    style="color: #006aff"
                    @click="$getStaticFile('准考证模板.docx')"
                    class="cp"
                  >
                    <i class="el-icon-download"></i>
                    下载准考证模板.docx
                  </span>
                </el-form-item>
                <div></div>
                <el-form-item
                  label="2.上传文件"
                  v-model="importForm.file"
                  label-width="90px"
                >
                  <ots-upload-file
                    :httpRequest="handleFormData"
                    fileType="docx"
                  />
                  <span class="col_grayZ"
                    >提示：只能修改考生须知内容，文件拓展名为.docx。</span
                  >
                </el-form-item>
                <div></div>
                <el-form-item label=" " label-width="90px">
                  <el-button round type="primary" @click="rightImport"
                    >确定上传</el-button
                  >
                  <el-button
                    round
                    plain
                    @click="leftShow"
                    v-if="entranceFilepath"
                    >预览准考证</el-button
                  >
                </el-form-item>
              </div>
            </el-form-item>
          </div>
        </div>
        <!-- 上传合格证 -->
        <div class="section mt20">
          <h4>上传合格证</h4>
          <div class="sectionBox">
            <el-form-item>
              <div class="stationBox">
                <el-form-item
                  label="上传文件"
                  v-model="certificate.file"
                  label-width="90px"
                >
                  <ots-upload-file
                    :httpRequest="certificateFormData"
                    fileType="pdf"
                  />
                  <span class="col_grayZ"
                    >提示：上传文件仅支持弘成设计的合格证。</span
                  >
                </el-form-item>
                <div></div>
                <el-form-item label=" " label-width="90px">
                  <el-button round type="primary" @click="certificateImport"
                    >确定上传</el-button
                  >
                  <el-button
                    round
                    plain
                    @click="certificateShow"
                    v-if="certificateFilepath"
                    >预览合格证</el-button
                  >
                </el-form-item>
              </div>
            </el-form-item>
          </div>
        </div>

        <!-- 申述表-->
        <div class="section mt20" v-if="form.scoreReview === 1">
          <h4>上传申诉表</h4>
          <div class="sectionBox">
            <el-form-item>
              <div class="stationBox">
                <el-form-item
                  label="上传文件"
                  v-model="Declaration.file"
                  label-width="90px"
                >
                  <ots-upload-file
                    :httpRequest="declarationcertificate"
                    fileType="pdf"
                  />
                  <span class="col_grayZ"
                    >提示：上传文件仅支持弘成设计的申诉表。</span
                  >
                </el-form-item>
                <div></div>
                <el-form-item label=" " label-width="90px">
                  <el-button round type="primary" @click="declara"
                    >确定上传</el-button
                  >
                  <el-button
                    round
                    plain
                    @click="scoreReviewShow"
                    v-if="scoreReviewFilepath"
                    >预览申诉表</el-button
                  >
                </el-form-item>
              </div>
            </el-form-item>
          </div>
        </div>

        <div class="section mt20">
          <h4>选择短信签名</h4>
          <div class="sectionBox">
            <el-form-item label="短信签名" prop="smsTitleId">
              <el-select v-model="form.smsTitleId" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <p
            style="margin-left: 160px; margin-bottom: 30px; font-size: 12px"
            class="col_red"
          >
            如您需要其他短信签名，请及时联系我们！
          </p>
        </div>
      </el-form>
    </layout-one>
  </div>
</template>
<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import { mapActions, mapMutations } from "vuex";
import { getSelectCourse } from "@/http/modules/baseSet/course";
import {
  addPlanFn,
  getTenantSmsTitle,
  editPlanFn,
  getPlanCodeFn,
  getSinglePlan,
  importEntranceTemplate,
  uploadPayPic,
  uploadCertificate,
  examTypeListApi
} from "@/http/modules/examSet/examBatch";
import { getTenantPayTypeApi } from "@/http/modules/student/payment";
export default {
  name: "addBatch",
  components: { VueUeditorWrap },
  data() {
    return {
      defaultTime: "23:59:59",
      // 考试类型
      signCoureCountall: false,
      options: [],
      scoreReviewFilepath: "",
      // 是否全选
      checkAll: false,
      // 全选样式
      isIndeterminate: true,
      // 缴费配置
      PayMentInfo: {
        // (1) 需要缴费的课程列表
        needPayCourse: [],
        // (2) 存储配置的缴费课程
        PayCourse: {},
      },
      // 初审截止 表单是否显示
      hiddenPrimaryEndAudit: false,
      // 终审/审核 截止时间文字描述
      endAuditLabel: "审核截止时间",
      // 终审/审核 表单是否显示
      hiddenEndAudit: true,
      // 预览合格证链接
      certificateFilepath: "",
      // 预览准考证链接
      entranceFilepath: "",
      // 编辑 ? 新增 ?
      isEdit: false,
      // 保存
      saveMethods: "addOrEdit",
      // 返回首页
      backMethods: "goIndex",
      // 批次名
      planCode: "",
      // 成绩查询开始时间
      dataFormat: "yyyy-MM-dd HH:mm:ss",
      // 快捷搜索
      courseStr: "",
      // 上一批次数据信息
      lastPlan: "",
      // 表单配置
      form: {
        examTypeId: "1",
        signCoureCount: "",
        smsTitleId: "",
        // 批次ID
        planId: "",
        // 考点场次
        optionalSession: "",
        //是否允许学生选考试日期
        optionalExamDate: "",
        // //每天预约人数限制
        everyBodyLimit: "0",
        // 下载准考证
        downloadEntrance: "",
        // 批次名
        //允许申述按钮
        scoreReview: "",
        name: "",
        // 审核方式
        needAudit: 1,
        // Ip 范围设置
        form_needIpCheck: false,
        // 科目金额(原单科目,已弃用)
        money: "",
        // 报名开始时间
        beginSign: "",
        // 报名截止时间
        endSign: "",
        // 初审截止时间
        primaryEndAudit: "",
        // 审核截止时间
        endAudit: "",
        // 缴费开始时间
        startPay: "",
        // 缴费截止时间
        endPay: "",
        // 准考证打印开始时间
        beginEntrance: "",
        // 考试开始时间
        beginExam: "",
        // 考试截止时间
        endExam: "",
        // 成绩查询时间
        beginScoreCheck: "",
        //成绩申诉截止时间
        scoreReviewEndTime: "",
        // 报名须知
        signRemark: "",
        // 考试须知
        examRemark: "",
        // 课程列表
        form_courseIdList: [],
        copyLastPlanFile: 0,
        // 是否缴费
        isPay: 1,
        // 缴费方式
        payType: "",
      },
      // 校验规则
      rules: {
        name: [
          { required: true, message: "请填写考试批次名称", trigger: "blur" },
          { min: 1, max: 30, message: "最多可输入30个字", trigger: "blur" },
        ],
        money: [{ required: true, message: "收费项必填", trigger: "blur" }],
        beginSign: [
          { required: true, message: "请选择报名开始时间", trigger: "change" },
        ],
        endSign: [
          { required: true, message: "请选择报名截止时间", trigger: "change" },
        ],
        endAudit: [
          { required: true, message: "请选择终审截止时间", trigger: "change" },
        ],
        primaryEndAudit: [
          { required: true, message: "请选择初审截止时间", trigger: "change" },
        ],
        startPay: [
          { required: true, message: "请选择缴费开始时间", trigger: "change" },
        ],
        endPay: [
          { required: true, message: "请选择缴费截止时间", trigger: "change" },
        ],
        beginEntrance: [
          {
            required: true,
            message: "请选择准考证打印时间",
            trigger: "change",
          },
        ],
        beginExam: [
          { required: true, message: "请选择考试开始时间", trigger: "change" },
        ],
        endExam: [
          { required: true, message: "请选择考试结束时间", trigger: "change" },
        ],
        beginScoreCheck: [
          {
            required: true,
            message: "请选择成绩查询开始时间",
            trigger: "change",
          },
        ],
        scoreReviewEndTime: [
          {
            required: true,
            message: "成绩申诉截止时间",
            trigger: "change",
          },
        ],
        signRemark: [
          { required: true, message: "请填写报名须知", trigger: "blur" },
        ],
        examRemark: [
          { required: true, message: "请填写考试须知", trigger: "blur" },
        ],
        form_courseIdList: [
          { required: true, message: "请勾选课程", trigger: "blur" },
        ],
        payType: [
          { required: true, message: "请选择缴费渠道", trigger: "blur" },
        ],
        smsTitleId: [
          { required: true, message: "请选择短信签名", trigger: "blur" },
        ],
      },
      importForm: {
        file: "",
      },
      certificate: {
        file: "",
      },
      Declaration: {
        file: "",
      },
      // 课程
      courseData: [],
      // 缴费二维码,缴费说明,缴费渠道
      payInfo: {
        imageUrl: "",
        onlinePayment: this.$route.query.payType,
        paymentText: "",
      },
      // 批次是否发布
      isPublish: false,
      // 场次是否发布, 终审截止时间是否禁用
      isClassPublish: false,
      // 是否创建场次
      isCreateSession: false,
      // 报名人工审核是否禁用
      isNeedAudit: false,
      // 当前时间
      currentTime: "",
      // 考试类型
      examTypeList: [],

      // 缴费类型
      payCode: '',
    };
  },

  computed: {
    courseSelectData() {
      return this.courseStr
        ? this.courseData.filter(
            (item) => item.name.indexOf(this.courseStr) > -1
          )
        : this.courseData;
    },
    payRemarkList() {
      return this.payInfo.paymentText
        ? this.payInfo.paymentText.split(";")
        : null;
    },
    isOverPay() {
      return this.form.endPay
        ? new Date().getTime(this.currentTime) <
          new Date(this.form.endPay).getTime()
          ? false
          : true
        : false;
    },
    isOverSign() {
      return this.form.endSign
        ? new Date().getTime(this.currentTime) <
          new Date(this.form.endSign).getTime()
          ? false
          : true
        : false;
    },
  },
  created() {
    this.initStatus();
    this.initCourseData();
    this.getCurrentTime();
  },
  mounted() {
    this.SAVE_PAGE_THIS(this);

    // 查询考试类型
    this.getExamTypeList();

    // 查询缴费类型
    this.getPayType();
  },
  watch: {
    "form.form_courseIdList"(val, index) {
      if (val.length >= 2) {
        this.signCoureCountall = true;
      } else {
        this.signCoureCountall = false;
      }
      if(!this.$route.query.id){
        this.form.optionalExamDate = 0;
        this.form.signCoureCount = 0;
      }
    },

    // "form.signCoureCount": function () {
    //   if (this.form.signCoureCount == 1) {
    //     this.form.optionalExamDate = 1;
    //   } else {
    //     this.form.optionalExamDate = 0;
    //     this.form.everyBodyLimit = "";
    //   }
    // },
  },
  methods: {
    ...mapActions("currentPlan", ["getCurrentPlanAction"]),
    ...mapMutations(["SAVE_PAGE_THIS"]),
    ...mapActions("selectOptions", ["getSelectPlanAction"]),
    
    /**
     * @param { 费用设置 => 缴费渠道 }
     */
    async getPayType() {
      const {data: payCode} = await getTenantPayTypeApi();
      this.payCode = Number(payCode);
      if (this.payCode == -1) {
        this.form.payType = '2';
      }
    },

    getExamTypeList(){
      examTypeListApi().then(res=>{
        if (res.code == 1) {
          this.examTypeList = res.data;
        }
      })
    },

    getCurrentTime() {
      this.mixin_getServerTime().then((res) => {
        this.currentTime = res.code == 1 ? res.data : "";
      });
    },

    examTypeChange(val) {
      this.hiddenPrimaryEndAudit = val == 2 ? true : false;
      this.hiddenEndAudit = val == 0 ? false : true;
      this.endAuditLabel =
        val == 1 ? "审核截止时间" : val == 2 ? "终审截止时间" : "";
    },

    async initStatus() {
      if (this.$route.query.id) {
        this.isEdit = true;
        const { data } = await getSinglePlan({ planId: this.$route.query.id });
        this.isNeedAudit = !data.isUpdate;
        for (let item in this.form) {
          this.form[item] = data[item] != null ? data[item] : this.form[item];
        }
        this.entranceFilepath = data.entranceFilepath;
        this.certificateFilepath = data.certificateFilepath;
        this.scoreReviewFilepath = data.scoreReviewFilepath;
        this.scoreReview = data.scoreReview;
        this.payInfo.imageUrl = data.payPic;
        this.payInfo.paymentText = data.payText;
        this.payInfo.onlinePayment = data.payType;
        this.PayMentInfo.needPayCourse = data.courseList;
        this.planCode = data.planCode;
        this.isClassPublish = data.classPublish == 1 ? true : false;
        this.isPublish = data.publish == 1 ? true : false;
        this.isCreateSession = data.isCreateSession == 1 ? true : false;
        this.form.form_needIpCheck = data.needIpCheck == 1 ? true : false;

        // 2023年11月14日
        if (!data.courseList) {
          data.courseList = [];
        }

        this.form.form_courseIdList = data.courseList.map((item) => item.id);
        this.handleCheckedChange(this.form.form_courseIdList);
        this.examTypeChange(data.needAudit);
        data.courseList.map((e) => {
          this.PayMentInfo.PayCourse[e.id] = e.money;
        });

      } else {
        this.isNeedAudit = false;
        this.initPlanCode();
      }
    },

    async initPlanCode() {
      const { data } = await getPlanCodeFn();
      this.planCode = data;
    },

    getLastPlan() {
      if (this.$route.name == "addBatch") {
        this.mixin_getCurrentPlanInfo().then((data) => {
          if (data) {
            this.lastPlan = data;
            this.copyLast();
          } else {
            return false;
          }
        });
      }
    },

    copyLast() {
      this.$confirm("是否复制上个考试批次配置", {
        confirmButtonText: "复制",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.copyPrevInfo(true);
        })
        .catch(() => {
          this.copyPrevInfo(false);
        });
    },

    copyPrevInfo(state) {
      if (state) {
        this.form.isPay = this.lastPlan.isPay;
        this.form.signRemark = this.lastPlan.signRemark;
        this.form.form_courseIdList = this.lastPlan.courseIdList;
        this.form.copyLastPlanFile = 1;
        this.form.payType = this.lastPlan.payType;
        this.form.money = this.lastPlan.money;
        this.form.payText = this.lastPlan.payText;
        this.form.downloadEntrance = this.lastPlan.downloadEntrance;
        this.form.scoreReview = this.lastPlan.scoreReview;
        this.form.optionalSession = this.lastPlan.optionalSession;
        this.payInfo.imageUrl = this.lastPlan.payPic;
        this.payInfo.paymentText = this.lastPlan.payText;
        this.entranceFilepath = this.lastPlan.entranceFilepath;
        this.certificateFilepath = this.lastPlan.certificateFilepath;
        this.from.scoreReviewFilepath = this.lastPlan.scoreReviewFilepath;
        this.form.scoreReviewEndTime = this.lastPlan.scoreReviewEndTime;
        this.handleCheckedChange(this.form.form_courseIdList);
      }
    },

    handleCheckedChange(value) {
      this.PayMentInfo.needPayCourse = [];
      this.courseData.map((e) => {
        if (value.includes(e.id)) {
          this.PayMentInfo.needPayCourse.push(e);
        }
      });
      this.checkAll = value.length == this.courseData.length;
      this.isIndeterminate =
        value.length > 0 && value.length < this.courseData.length;

      return false;
    },

    async initCourseData() {
      const { data } = await getSelectCourse();
      this.courseData = data;
      getTenantSmsTitle().then((res) => {
        this.options = res.data;
      });
    },

    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      this.form.form_courseIdList = val
        ? this.courseData.map((item) => item.id)
        : [];
      this.PayMentInfo.needPayCourse = val ? this.courseData : [];
    },

    handleFormData(val) {
      this.importForm.file = val.file;
    },

    certificateFormData(val) {
      this.certificate.file = val.file;
    },
    declarationcertificate(val) {
      this.Declaration.file = val.file;
    },

    /**
     * @param { 修改/新增 批次}
     */
    async addOrEdit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let params = { ...this.form };
          if(params.optionalSession == 1){
            params.optionalExamDate = 0;
            params.everyBodyLimit= 0;
          }
         
          // 批次对接需求修改
          if (params.optionalExamDate == '') { params.optionalExamDate = 0 }


          if(params.everyBodyLimit == ''){
            params.everyBodyLimit = 0;
          }
          // (1) 课程是否选择
          if (!params.form_courseIdList.length) {
            this.$message.warning("请选择课程");
            return false;
          }
          // (2) 缴费开启
          if (params.isPay == 1) {
            // (2.1) 缴费开启, 是否选择缴费渠道
            if (!params.payType) {
              this.$message.warning("请选择缴费渠道！");
              return false;
            }
            // (2.2) 配置 "课程#费用" 参数
            let courseIdList = [];
            let coursePayList = [];
            this.form.form_courseIdList.map((item) => {
              let obj = {};
              obj[item] = 0;
              courseIdList.push(obj);
            });
            courseIdList.map((e, i) => {
              for (let key in this.PayMentInfo.PayCourse) {
                // 2023年10月24日 
                if (this.PayMentInfo.PayCourse[key] == '') this.PayMentInfo.PayCourse[key] = 0
                if (this.form.form_courseIdList.includes(key)) {
                  for (let index in courseIdList[i]) {
                    if (key == index) {
                      courseIdList[i][index] = this.PayMentInfo.PayCourse[key];
                    }
                  }
                }
              }
            });
            courseIdList.map((e) => {
              let str = Object.keys(e)[0] + "#" + Object.values(e)[0];
              coursePayList.push(str);
            });
            params.courseIdList = coursePayList.join();
          } else {
            params.courseIdList = params.form_courseIdList.join();
          }
          // (3) 审核状态
          params.needAudit = params.needAudit;
          // (4) 是否需要 IP 范围设置;
          params.needIpCheck = params.form_needIpCheck ? 1 : 0;
          // (5) 缴费说明
          params.payText = this.payInfo.paymentText;
          // (6) 删除 "form_" 相关参数
          for (let key in params) {
            if (key.startsWith("form_")) {
              delete params[key];
            }
          }
          // (7) 判断是否需要上传准考证
          if (!this.entranceFilepath && this.form.downloadEntrance == 1) {
            this.$message.warning("您已勾选“下载准考证选项”，请上传准考证！");
            return false;
          } else {
            // (8) 判断 修改/新增 批次
            const dealFn = this.isEdit ? editPlanFn : addPlanFn;
            // (9) 调用 修改/新增 接口
            const { code } = await dealFn(params);
            // (10) 返回首页
            if (code == 1) {
              this.$otsPopPro({
                content: this.isEdit ? "修改成功" : "添加成功",
                isNeedCancel: false,
                okName: "确定",
              }).then(() => {
                this.goIndex();
              });
              // (11) 执行 vuex 查询批次
              this.getSelectPlanAction();
              // (12) 执行 vuex 更新 currentPlan
              this.getCurrentPlanAction();
            }
          }
        } else {
          return false;
        }
      });
    },

    async rightImport() {
      if (!this.importForm.file) {
        this.$message.error("请选择文件");
        return;
      }
      const fd = new FormData();
      if (this.isEdit) {
        this.importForm.planId = this.$route.query.id;
      }
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item]);
      }
      const { code, data } = await importEntranceTemplate(fd);
      if (code == 1) {
        this.$message.success("上传成功");
        this.importForm.file = "";
        this.entranceFilepath = data;
      }
    },

    async certificateImport() {
      if (!this.certificate.file) {
        this.$message.error("请选择文件");
        return;
      }
      const fd = new FormData();
      for (let item in this.certificate) {
        fd.append(item, this.certificate[item]);
        fd.append("templateType", "1");
      }

      const { code, data } = await uploadCertificate(fd);
      if (code == 1) {
        this.$message.success("上传成功");
        this.certificateFilepath = data;
      }
    },
    async declara() {
      if (!this.Declaration.file) {
        this.$message.error("请选择文件");
        return;
      }
      const fd = new FormData();
      for (let item in this.Declaration) {
        fd.append(item, this.Declaration[item]);
        fd.append("templateType", "2");
      }

      const { code, data } = await uploadCertificate(fd);
      if (code == 1) {
        this.$message.success("上传成功");
        this.scoreReviewFilepath = data;
      }
    },

    async leftShow() {
      window.open(this.entranceFilepath);
    },

    async certificateShow() {
      window.open(this.certificateFilepath);
    },
    async scoreReviewShow() {
      window.open(this.scoreReviewFilepath);
    },
    goIndex() {
      this.$router.push({ name: "examBatch" });
    },

    beforeAvatarUpload(file) {
      const configType = ["png", "jpg", "jpeg"];
      const imageType = file.type.split("/")[1].toLowerCase();
      const pettern = /^image/;
      const isImg = pettern.test(file.type) && configType.includes(imageType);
      const isLimit = file.size / 1024 < 200;
      if (!isImg) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
      }
      if (!isLimit) {
        this.$message.error("上传图片大小不能超过 200KB!");
      }
      return isImg && isLimit;
    },

    uploadImg(data) {
      let that = this;
      let fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = async function (e) {
        const fd = new FormData();
        fd.append("file", fileData);
        if (that.isEdit) {
          fd.append("planId", that.$route.query.id);
        }
        const { code } = await uploadPayPic(fd);
        if (code == 1) {
          that.$message.success("上传成功");
          if (this.result) {
            that.payInfo.imageUrl = this.result;
          }
        }
      };
    },
  },
};
</script>

<style lang="less" scoped>
.section {
  border-bottom: 1px solid #f1f2f5;
  h4 {
    margin-bottom: 30px;
  }
  .sectionBox {
    .lang {
      width: 512px;
    }
    .examType {
      width: 120px;
      margin-right: 16px;
      /deep/ .el-radio-button__inner {
        width: 100%;
      }
    }
  }
  .stationBox {
    width: 1000px;
    max-height: 300px;
    background-color: #f8f9fc;
    overflow-y: auto;
    padding: 20px 70px;
    border-radius: 8px;
    .stationTop {
      display: flex;
      margin-bottom: 20px;
    }
    .searchCourse {
      position: relative;
      .searchPos {
        width: 40px;
        height: 18px;
        line-height: 18px;
        border-left: 1px solid #e1e6ed;
        position: absolute;
        right: 0;
        top: 11px;
        color: #c2c6cc;
        font-size: 14px;
        i {
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }
  .editor {
    width: 800px;
  }
  .unEditor {
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    border-radius: 3px;
    padding: 8px;
    width: 800px;
    height: 200px;
    overflow: auto;
    line-height: 1.5;
    overflow-wrap: break-word;
  }
  /deep/ .el-form-item {
    margin-bottom: 30px !important;
  }
  /deep/ .el-radio-button__inner {
    margin-right: 16px;
    color: #45494d !important;
    background: #f4f5f8 !important;
    font-size: 13px;
    border-radius: 4px !important;
    border: 1px solid #dadde6 !important;
    width: 64px;
    height: 32px;
    line-height: 32px;
    padding: 0;
  }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #ebf5ff !important;
    border: 1px solid #006aff !important;
    color: #006aff !important;
    box-shadow: none;
  }
  /deep/ .el-checkbox {
    width: 360px;
    overflow: hidden;
    white-space: nowrap;
  }
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 131px;
  height: 131px;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #006aff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 131px;
  height: 131px;
  line-height: 131px;
  text-align: center;
  position: absolute;
  top: 0%;
  left: 0%;
}
.avatar-uploader /deep/ .el-upload:hover .avatar-uploader-icon {
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 3;
}
.avatar /deep/ {
  width: 131px;
  height: 131px;
  position: absolute;
  top: 0%;
  left: 0%;
  z-index: 2;
}
.avatarTip {
  padding-top: 8px;
  display: inline-block;
  vertical-align: top;
  margin-left: 20px;
  line-height: 1.8;
}
.textarea {
  width: 500px;
  height: 80px;
  /deep/ .el-textarea__inner {
    height: 100%;
  }
}
.preBtn:hover .codePreview {
  display: flex;
}
.codePreview {
  bottom: -60px;
  left: 40px;
  width: 405px;
  min-height: 487px;
  background: #ffffff;
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.12);
  border: 1px solid #dadde6;
  border-radius: 4px;
  position: absolute;
  display: none;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 32px;
  box-sizing: border-box;
  z-index: 2;
  .picArea {
    width: 280px;
    height: 280px;
    padding: 10px;
    box-sizing: border-box;
    margin: 20px auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .payContent {
    width: 100%;
    word-break: break-word;
  }
}
.limitationcheckbox {
  width: 430px !important;
  color: #606266;
  /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #606266;
  }
}
.limitationcheckboxs {
  width: 330px !important;
  color: #606266;
  /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #606266;
  }
}
.inputwidth /deep/.el-input__inner {
  width: 500px !important;
}
.inputsize {
  width: 100px;
margin-left: 5px;
  /deep/.el-input__inner {
    width: 90px;
    height: 26px;
  }
}
</style>
